"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayStatusType = void 0;
var PayStatusType;
(function (PayStatusType) {
    PayStatusType["N_A"] = "N/A";
    PayStatusType["AT"] = "1 - AT";
    PayStatusType["RPA_OR_MPA"] = "1 - RPA or MPA";
    PayStatusType["UTA_OR_RUTA"] = "2 - UTA or RUTA";
    PayStatusType["FTP"] = "3 - FTP";
    PayStatusType["GTP"] = "3 - GTP";
    PayStatusType["CIVILIAN"] = "4 - Civilian";
})(PayStatusType = exports.PayStatusType || (exports.PayStatusType = {}));
